import { useTranslation } from "react-i18next"

function NotTranslatable() {
  const { t, i18n } = useTranslation()

  return i18n.language?.split("-")[0] !== "en" ? <p>{t("common.notTranslatable")}</p> : <></>
}

export default NotTranslatable
